import { Outlet } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import MobileBottomNav from '../components/common/MobileBottomNav';

const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-brand-cream" data-testid="public-layout">
      <div className="grain-overlay"></div>
      <Navbar />
      <main className="flex-1 main-content">
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
};

export default PublicLayout;
